// extracted by mini-css-extract-plugin
export default {"container":"Bo-z"};